import React from 'react';

import EventIcon from '@material-ui/icons/Event';
import RouteConfig from '../../config/appRoute/RouteConfig';
import { FUNCTIONS } from '../../constants/APDConstants';

const EventManagementMenu = [
    {
        functionId: FUNCTIONS.EVENT_MANAGEMENT.id,
        icon: <EventIcon />,
        label: 'จัดการกิจกรรม',
        to: RouteConfig.EVENT_MANAGEMENT,
        isPublic: true,
    },
];

export default EventManagementMenu;
